/** System administrator (`UserTypeEnum.Admin`). */
export const SYSTEM_ADMIN_USER_TYPE = 1

/**
 * Export ZIP di incidenti salvati in locale (operazione sul device).
 * L'admin globale non ha organizzazione fissa e non può importare sul server.
 *
 * @param {number | undefined | null} userType
 * @returns {boolean}
 */
export function canExportLocalCrashData(userType) {
  const type = Number(userType)
  return type !== SYSTEM_ADMIN_USER_TYPE
}

/**
 * Creazione / salvataggio incidenti in modalità offline.
 *
 * @param {number | undefined | null} userType
 * @returns {boolean}
 */
export function canCreateOfflineCrash(userType) {
  return canExportLocalCrashData(userType)
}
